__webpack_require__.p = "/it_kl_projekt/";